import { useState, useEffect } from "react";
import TemplatePage from "./App";
import Tabs from "./Custom/Tabs";
import { Card, CardBody, Offcanvas } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import Cookies from 'js-cookie';
import CustomButton from "./Custom/CustomButton";

// Cookieに保存するためのユーティリティ関数
const setCookie = (name: string, value: string, days: number) => {
    Cookies.set(name, value, { expires: days });
}

const EditVideo = () => {
    // サイズ等の設定用フック
    const [viewSize, setViewSize] = useState('300');
    const [inputViewSize, setInputViewSize] = useState('180');
    const [previewShow, setPreviewShow] = useState(true);

    // offcanbas用のフック
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const storedViewSize = Cookies.get('viewSize');
        const storedInputViewSize = Cookies.get('InputViewSize');
        const storedPreviewShowState = Cookies.get('previewShowState');

        if (storedViewSize) {
            let size = decodeURIComponent(storedViewSize);
            setViewSize(size);
        } else {
            let baseSize = "200";
            setViewSize(baseSize);
        }
        if (storedInputViewSize) {
            let inputSize = decodeURIComponent(storedInputViewSize);
            setInputViewSize(inputSize);
        } else {
            let baseSize = "180";
            setInputViewSize(baseSize);
        }
        if (storedPreviewShowState !== undefined) {
            setPreviewShow(decodeURIComponent(storedPreviewShowState) === 'true');
        } else {
            setPreviewShow(true);
        }

        // ウィンドウ幅を監視してレイアウトを切り替え
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768); // 768px以下をスマホと判定
        };

        // 初回実行
        handleResize();

        // リサイズイベントを監視
        window.addEventListener('resize', handleResize);

        // クリーンアップ
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const mainBoxStyle: React.CSSProperties = {
        boxSizing: "border-box",
        whiteSpace: "normal",
        padding: "1em",
        width: "665px",
        maxWidth: "100%",
        height: "364.5px",
        maxHeight: "100%",
        backgroundColor: "#000",
        borderRadius: "1.5em",
        overflow: "auto",
    };

    // スマホ表示用
    const spBoxStyle: React.CSSProperties = {
        boxSizing: "border-box",
        whiteSpace: "normal",
        padding: "1em",
        width: "375px",
        maxWidth: "100%",
        height: "354.3px",
        maxHeight: "100%",
        backgroundColor: "#000",
        borderRadius: "1.5em",
        overflow: "auto",
    };

    const tagBoxStyle: React.CSSProperties = {
        boxSizing: "border-box",
        whiteSpace: "normal",
        padding: "0em",
        width: "8em",
        maxWidth: "100%",
        lineHeight: "2em",
        borderRadius: "3.5em",
        border: "1px solid #000",
        backgroundColor: "#fff",
        color: "#202020",
        overflow: "auto",
    };

    const tagTextStyle: React.CSSProperties = {
        display: "inline-block",
        fontSize: "0.8em",
    };


    return (
        <TemplatePage>
            <Offcanvas show={show} onHide={handleClose}>
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>全体の設定一覧</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>

                </Offcanvas.Body>
            </Offcanvas>

            {isMobile ? (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Card style={spBoxStyle}>
                        <CardBody>
                            <h1 style={{ color: "red" }}>現在開発中です</h1>
                            <p></p>
                            <p>進捗状況に関してはトップページを御覧下さい。</p>
                            <p></p>
                        </CardBody>
                    </Card>
                </div>
            ) : (
                <div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <div className="row">
                            <div className="col" style={{ padding: "1em", backgroundColor: "#e6fcd2" }}>
                                <Card style={mainBoxStyle}>
                                    <h4 style={{color: "#fff"}}>ここに動画のタイトル</h4>
                                </Card>
                            </div>
                            <div className="col" style={{ padding: "1em", }}>
                                <Card style={{ boxSizing: "border-box", whiteSpace: "normal", padding: "1em", width: "375px", maxWidth: "100%", height: "364.5px", maxHeight: "100%", backgroundColor: "#000", borderRadius: "1.5em", overflow: "auto" }}>
                                    <CardBody>
                                        <h1 style={{ color: "red" }}>現在開発中です</h1>
                                        <p></p>
                                        <p>進捗状況に関してはトップページを御覧下さい。</p>
                                        <p></p>
                                    </CardBody>
                                </Card>
                            </div>
                        </div>
                    </div>
                    <div style={{ display: 'flex', justifyContent: 'center' }}>
                        <div className="row">
                            <div className="col" style={{ padding: "1em", backgroundColor: "#e6fcd2" }}>
                                <Card style={{ boxSizing: "border-box", whiteSpace: "normal", padding: "1em", width: "665px", maxWidth: "100%", maxHeight: "100%", backgroundColor: "#fff", borderRadius: "1.5em", overflow: "auto" }}>
                                    <CardBody>
                                        <h2 style={{ color: "black" }}>ここに動画のタイトル</h2>
                                        <p style={{ fontSize: "14px" }}>1000 回視聴 1 時間前</p>

                                        <div className="row">
                                            <div className="col">
                                                <div className="tag_box bgcolor"
                                                    style={{ boxSizing: "border-box", whiteSpace: "normal", padding: "1em", width: "3em", maxWidth: "100%", height: "3em", maxHeight: "100vh", backgroundColor: "#000", borderRadius: "3.5em", overflow: "auto" }}></div>
                                            </div>
                                            <div className="col">
                                                <span>ここにチャンネル名</span>
                                            </div>
                                            <div className="col">
                                                200万人
                                            </div>
                                            <div className="col">
                                                <div className="tag_box bgcolor" style={tagBoxStyle}>
                                                    <div style={{ textAlign: "center" }}>
                                                        <span className="tag_text" style={tagTextStyle}>チャンネル登録</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <p></p>
                                    </CardBody>
                                </Card>
                            </div>
                            <div className="col" style={{ padding: "1em", }}>
                                <Card style={{ boxSizing: "border-box", whiteSpace: "normal", padding: "1em", width: "375px", maxWidth: "100%", maxHeight: "100%", backgroundColor: "#fff", borderRadius: "1.5em", overflow: "auto" }}>
                                    <CardBody>
                                        <CustomButton size="sm" variant="primary" onClick={handleShow}>
                                        <i className="bi bi-tools"></i> 全体の設定一覧
                                        </CustomButton>
                                    </CardBody>
                                </Card>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </TemplatePage>
    );
}

export default EditVideo;